export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9422.0ee23460.jpg";